import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const initialState = {
  gender :{
    currentStep : 1,
    file: '',
    allColumns : [],
    rowData: [],
    matchedColumn: "",
    allGenderMapping : []
  },
  positions : {
    currentStep : 1,
    file: '',
    allColumns : [],
    rowData: [],
    matchedColumns: [],
    allOccupationsMapping : [],
    allSeniorityMapping : []
  },
  performance : {
    currentStep : 1,
    file: '',
    allColumns : [],
    rowData: [],
    matchedColumn: "",
    allPerformanceMapping : []
  },
  ethnicity : {
    currentStep : 1,
    file: '',
    allColumns : [],
    rowData: [],
    matchedColumn: "",
    allEthnicityMapping : []
  },



  veteran : {
    currentStep : 1,
    file: '',
    allColumns : [],
    rowData: [],
    matchedColumn: "",
    allVeteranMapping : []
  },
  disability : {
    currentStep : 1,
    file: '',
    allColumns : [],
    rowData: [],
    matchedColumn: "",
    allDisabilityMapping : []
  },
  sexualOrientation : {
    currentStep : 1,
    file: '',
    allColumns : [],
    rowData: [],
    matchedColumn: "",
    allSexualOrientationMapping : []
  },
  religion : {
    currentStep : 1,
    file: '',
    allColumns : [],
    rowData: [],
    matchedColumn: "",
    allReligionMapping : []
  },


  separation : {
    currentStep : 1,
    file: '',
    allColumns : [],
    rowData: [],
    matchedColumn: "",
    allSeparationMapping : []
  }
};

export default function (state = initialState, action) {
    switch (action.type) {
      /**
       * Map gender 
       */
      case actionTypes.MAP_GENDER_NEXT_STEP: 
        return {...state,gender : {...state.gender,currentStep : state.gender.currentStep + 1}};
      case actionTypes.MAP_GENDER_PREVIOUS_STEP :
      return {...state,gender : {...state.gender,currentStep : state.gender.currentStep - 1}};
      case actionTypes.MAP_GENDER_UPLOAD_FILE_SUCCESS :
        return {
          ...state, 
          gender : {
            ...state.gender,
            allColumns : action.val.columns, 
            rowData : action.val.data, 
            file: action.val.file
          }
        }
      case actionTypes.MAP_GENDER_MATCH_COLUMN_SUCCESS :
        return {...state, gender : {...state.gender,matchedColumn : action.val}};
      case actionTypes.MAP_GENDER_SAVE_GENDER_MAPPING :
        return {...state, gender : {...state.gender,allGenderMapping : action.val}};
      case actionTypes.MAP_GENDER_RESET :
        return {...state, gender : initialState.gender};
      case actionTypes.MAP_GENDER_RESET_STEP: 
        return {...state, gender : {...state.gender,currentStep : 1}};
       /**
       * Map positions 
       */
      case actionTypes.MAP_POSITIONS_NEXT_STEP: 
      return {...state,positions : 
        {...state.positions,
          currentStep : state.positions.currentStep + 1}};
      case actionTypes.MAP_POSITIONS_PREVIOUS_STEP :
      return {...state,positions : 
        {...state.positions,
          currentStep : state.positions.currentStep - 1}};
      case actionTypes.MAP_POSITIONS_NEXT_STEP: 
        return {...state,positions : 
          {...state.positions,
            currentStep : 1}};
      case actionTypes.MAP_POSITIONS_UPLOAD_FILE_SUCCESS :
      return {...state, 
        positions : {
          ...state.positions,
          allColumns : action.val.columns, rowData : action.val.data, file: action.val.file}
        }
      case actionTypes.MAP_POSITIONS_MATCH_COLUMN_SUCCESS :
      return {...state, positions : {...state.positions,matchedColumns : action.val}};
      case actionTypes.MAP_POSITIONS_SAVE_POSITIONS_MAPPING :
        return {...state, positions : {...state.positions,
          allOccupationsMapping : action.val.occupations, 
          allSeniorityMapping : action.val.seniority
          }
        };
      case actionTypes.MAP_POSITIONS_RESET :
        return {...state, positions : initialState.positions};
      
      case actionTypes.MAP_POSITIONS_RESET_STEP: 
        return {...state, positions : {...state.positions, currentStep : 1}};
      /**
       * Map performance 
       */
      case actionTypes.MAP_PERFORMANCE_NEXT_STEP: 
        return {...state,performance : 
          {...state.performance,
            currentStep : state.performance.currentStep + 1}};
      case actionTypes.MAP_PERFORMANCE_PREVIOUS_STEP :
      return {...state,performance : 
        {...state.performance,
          currentStep : state.performance.currentStep - 1}};
      case actionTypes.MAP_PERFORMANCE_UPLOAD_FILE_SUCCESS :
        return {...state, 
          performance : 
          {
            ...state.performance,
            allColumns : action.val.
            columns, rowData : action.val.data, 
            file: action.val.file
          }
        }
      case actionTypes.MAP_PERFORMANCE_MATCH_COLUMN_SUCCESS :
        return {...state, performance : {...state.performance,matchedColumn : action.val}};
      case actionTypes.MAP_PERFORMANCE_SAVE_PERFORMANCE_MAPPING :
        return {...state, performance : {...state.performance,allPerformanceMapping : action.val}};
      case actionTypes.MAP_PERFORMANCE_RESET :
        return {...state, performance : initialState.performance};

      case actionTypes.MAP_PERFORMANCE_RESET_STEP: 
        return {...state, performance : {...state.performance, currentStep : 1}};




        
        /**
       * Map Veteran 
       */

      case actionTypes.MAP_VETERAN_NEXT_STEP: 
      return {...state,veteran : 
        {...state.veteran,
          currentStep : state.veteran.currentStep + 1}};
    case actionTypes.MAP_VETERAN_PREVIOUS_STEP :
    return {...state,veteran : 
      {...state.veteran,
        currentStep : state.veteran.currentStep - 1}};
    case actionTypes.MAP_VETERAN_UPLOAD_FILE_SUCCESS :
      return {...state, 
        veteran : 
        {
          ...state.veteran,
          allColumns : action.val.
          columns, rowData : action.val.data, 
          file: action.val.file
        }
      }
    case actionTypes.MAP_VETERAN_MATCH_COLUMN_SUCCESS :
      return {...state, veteran : {...state.veteran,matchedColumn : action.val}};
    case actionTypes.MAP_VETERAN_SAVE_VETERAN_MAPPING :
      return {...state, veteran : {...state.veteran,allVeteranMapping : action.val}};
    case actionTypes.MAP_VETERAN_RESET :
      return {...state, veteran : initialState.veteran};

    case actionTypes.MAP_VETERAN_RESET_STEP: 
      return {...state, veteran : {...state.veteran, currentStep : 1}};



       /**
       * Map Sexual Orientation 
       */

      case actionTypes.MAP_SEXUAL_ORIENTATION_NEXT_STEP: 
      return {...state,sexualOrientation : 
        {...state.sexualOrientation,
          currentStep : state.sexualOrientation.currentStep + 1}};
    case actionTypes.MAP_SEXUAL_ORIENTATION_PREVIOUS_STEP :
    return {...state,sexualOrientation : 
      {...state.sexualOrientation,
        currentStep : state.sexualOrientation.currentStep - 1}};
    case actionTypes.MAP_SEXUAL_ORIENTATION_UPLOAD_FILE_SUCCESS :
      return {...state, 
        sexualOrientation : 
        {
          ...state.sexualOrientation,
          allColumns : action.val.
          columns, rowData : action.val.data, 
          file: action.val.file
        }
      }
    case actionTypes.MAP_SEXUAL_ORIENTATION_MATCH_COLUMN_SUCCESS :
      return {...state, sexualOrientation : {...state.sexualOrientation,matchedColumn : action.val}};
    case actionTypes.MAP_SEXUAL_ORIENTATION_SAVE_SEXUAL_ORIENTATION_MAPPING :
      return {...state, sexualOrientation : {...state.sexualOrientation,allSexualOrientationMapping : action.val}};
    case actionTypes.MAP_SEXUAL_ORIENTATION_RESET :
      return {...state, sexualOrientation : initialState.sexualOrientation};

    case actionTypes.MAP_SEXUAL_ORIENTATION_RESET_STEP: 
      return {...state, sexualOrientation : {...state.sexualOrientation, currentStep : 1}};





      /**
       * Map Religion
       */

      case actionTypes.MAP_RELIGION_NEXT_STEP: 
      return {...state,religion : 
        {...state.religion,
          currentStep : state.religion.currentStep + 1}};
    case actionTypes.MAP_RELIGION_PREVIOUS_STEP :
    return {...state,religion : 
      {...state.religion,
        currentStep : state.religion.currentStep - 1}};
    case actionTypes.MAP_RELIGION_UPLOAD_FILE_SUCCESS :
      return {...state, 
        religion : 
        {
          ...state.religion,
          allColumns : action.val.
          columns, rowData : action.val.data, 
          file: action.val.file
        }
      }
    case actionTypes.MAP_RELIGION_MATCH_COLUMN_SUCCESS :
      return {...state, religion : {...state.religion,matchedColumn : action.val}};
    case actionTypes.MAP_RELIGION_SAVE_RELIGION_MAPPING :
      return {...state, religion : {...state.religion,allReligionMapping : action.val}};
    case actionTypes.MAP_RELIGION_RESET :
      return {...state, religion : initialState.religion};

    case actionTypes.MAP_RELIGION_RESET_STEP: 
      return {...state, religion : {...state.religion, currentStep : 1}};




      /**
       * Map Disability
       */

      case actionTypes.MAP_DISABILITY_NEXT_STEP: 
      return {...state,disability : 
        {...state.disability,
          currentStep : state.disability.currentStep + 1}};
    case actionTypes.MAP_DISABILITY_PREVIOUS_STEP :
    return {...state,disability : 
      {...state.disability,
        currentStep : state.disability.currentStep - 1}};
    case actionTypes.MAP_DISABILITY_UPLOAD_FILE_SUCCESS :
      return {...state, 
        disability : 
        {
          ...state.disability,
          allColumns : action.val.
          columns, rowData : action.val.data, 
          file: action.val.file
        }
      }
    case actionTypes.MAP_DISABILITY_MATCH_COLUMN_SUCCESS :
      return {...state, disability : {...state.disability,matchedColumn : action.val}};
    case actionTypes.MAP_DISABILITY_SAVE_DISABILITY_MAPPING :
      return {...state, disability : {...state.disability,allDisabilityMapping : action.val}};
    case actionTypes.MAP_DISABILITY_RESET :
      return {...state, disability : initialState.disability};

    case actionTypes.MAP_DISABILITY_RESET_STEP: 
      return {...state, disability : {...state.disability, currentStep : 1}};






      /**
       * Map Ethnicity 
       */

        case actionTypes.MAP_ETHNICITY_NEXT_STEP: 
        return {...state,ethnicity : 
          {...state.ethnicity,
            currentStep : state.ethnicity.currentStep + 1}};
      case actionTypes.MAP_ETHNICITY_PREVIOUS_STEP :
      return {...state,ethnicity : 
        {...state.ethnicity,
          currentStep : state.ethnicity.currentStep - 1}};
      case actionTypes.MAP_ETHNICITY_UPLOAD_FILE_SUCCESS :
        return {...state, 
          ethnicity : 
          {
            ...state.ethnicity,
            allColumns : action.val.
            columns, rowData : action.val.data, 
            file: action.val.file
          }
        }
      case actionTypes.MAP_ETHNICITY_MATCH_COLUMN_SUCCESS :
        return {...state, ethnicity : {...state.ethnicity,matchedColumn : action.val}};
      case actionTypes.MAP_ETHNICITY_SAVE_ETHNICITY_MAPPING :
        return {...state, ethnicity : {...state.ethnicity,allEthnicityMapping : action.val}};
      case actionTypes.MAP_ETHNICITY_RESET :
        return {...state, ethnicity : initialState.ethnicity};

      case actionTypes.MAP_ETHNICITY_RESET_STEP: 
        return {...state, ethnicity : {...state.ethnicity, currentStep : 1}};
      /**
       * Map separation 
       */
      case actionTypes.MAP_SEPARATION_NEXT_STEP: 
      return {...state,separation : 
        {...state.separation,
          currentStep : state.separation.currentStep + 1}};
      case actionTypes.MAP_SEPARATION_PREVIOUS_STEP :
      return {...state,separation : 
        {...state.separation,
          currentStep : state.separation.currentStep - 1}};
      case actionTypes.MAP_SEPARATION_UPLOAD_FILE_SUCCESS :
      return {...state, 
        separation : {
          ...state.separation,
          allColumns : action.val.columns, rowData : action.val.data, file: action.val.file}
        }
      case actionTypes.MAP_SEPARATION_MATCH_COLUMN_SUCCESS :
      return {...state, separation : {...state.separation,matchedColumn : action.val}};
      case actionTypes.MAP_SEPARATION_SAVE_SEPARATION_MAPPING :
        return {...state, separation : {...state.separation,
          allSeparationMapping : action.val }
        };
      case actionTypes.MAP_SEPARATION_RESET :
        return {...state, separation : initialState.separation};

      case actionTypes.MAP_SEPARATION_RESET_STEP: 
        return {...state, separation : {...state.separation, currentStep : 1}};
      default:
        break;
    }
    return state;
}